import * as types from "../actionTypes";
import { getEventHighlightData, getEventPlayerHighlights, getPlayerHighlightData, getShareData } from "../../api";
import helper from "../../helpers/helper";
import getQueryParams from "../../helpers/getQueryParams";

export const actions = {
    /** action for fetch clip's video data **/
    [types.FETCH_SHARE_REQUEST]({ commit }, { type, id }) {
        return getShareData(id)
            .then(helper.errorResponseCheck)
            .then(response => response.json())
            .then(response => {
                const { id, attributes, nextEventToken, prevEventToken } = response;
                const { name, urls, target, targetId } = attributes;
                const eventId = target ? target.events[0] : targetId;

                const formattedData = {
                    id,
                    type,
                    attributes: {
                        name,
                        urls,
                        eventId
                    }
                };

                const additionalEvents = { nextEventToken, prevEventToken };

                commit(types.ADD_STREAMS, [formattedData]);

                return [formattedData, additionalEvents];
            })
    },

    /** action for fetch event highlight's video data **/
    [types.FETCH_EVENT_HIGHLIGHT_REQUEST]({ commit }, id) {
        return getEventHighlightData(id)
            .then(helper.errorResponseCheck)
            .then(response => response.json())
            .then(response => {
                const { attributes, id, type, nextEventToken, prevEventToken } = response.data;

                const formattedData = {
                    id,
                    type,
                    attributes
                };

                const additionalEvents = { nextEventToken, prevEventToken };

                commit(types.ADD_STREAMS, [formattedData]);

                return [formattedData, additionalEvents];
            })
    },


    [types.FETCH_PLAYER_HIGHLIGHTS_REQUEST]({ state, commit }, eventId) {
        const hashQuery = window.location.hash && window.location.hash.substr(1);
        const { 'x-ph-source': source } = getQueryParams(window.location.href) || getQueryParams(hashQuery);

        return getEventPlayerHighlights(eventId, source)
            .then(helper.errorResponseCheck)
            .then(response => response.json())
            .then(response => {
                const streams = response.data.map(item => {
                    const { id, attributes } = item;

                    return {
                        id,
                        type: 'player-highlight',
                        attributes: {
                            ...attributes,
                            eventId
                        }
                    }
                });

                const playerHighlightIndex = streams
                    .findIndex(item => state.video.streams.data.some(i => item.id === i.id));

                if (playerHighlightIndex !== -1) {
                    streams.splice(playerHighlightIndex, 1);
                }

                commit(types.ADD_STREAMS, streams);

                return response;
            })
    },

    /** action for fetch player highlight's video data **/
    [types.FETCH_PLAYER_HIGHLIGHT_REQUEST]({ commit }, id) {
        return getPlayerHighlightData(id)
            .then(helper.errorResponseCheck)
            .then(response => response.json())
            .then(response => {
                const { id, attributes, nextEventToken, prevEventToken } = response.data;

                const formattedData = {
                    id,
                    type: 'player-highlight',
                    attributes
                };

                const additionalEvents = { nextEventToken, prevEventToken };

                commit(types.ADD_STREAMS, [formattedData]);

                return [formattedData, additionalEvents];
            })
    },
}
